/**
 * THE WORKSPACE'S ENTRY POINT — mount the shell, and nothing else.
 *
 * There is no bootstrap read here and no credential to resolve, because there
 * is nothing to resolve: the session belongs to the identity provider, the
 * workspace learns whether it has one by asking Scout a question, and a failed
 * question renders as a failed question rather than as a blank page.
 */

import { render } from 'preact';
import { App } from './app';
import './styles/tokens.css';
import './styles/app.css';
// THE LANDING'S OWN PALETTE IS A SEPARATE FILE, and that is deliberate: the
// workspace's tokens are a light/dark pair the Owner chooses between, and the
// landing is one dark identity that every deployment shares. Putting them in
// one file would put two answers to "what colour is the background" in one
// place, which is how a surface ends up inheriting the wrong one.
import './styles/landing.css';
import { registerServiceWorker } from './service-worker-client';

const root = document.getElementById('scout-root');

if (root === null) {
	// THE ONLY CASE WHERE AN ERROR IS SWALLOWED, and it is not really swallowed:
	// there is no element to render into, so there is nowhere to say anything.
	// The document itself is wrong at that point, not the request.
	console.error('[scout] #scout-root is missing from the document; nothing was mounted.');
} else {
	render(<App />, root);
	// REGISTERED AFTER THE RENDER AND AWAITED BY NOTHING. Installing a service
	// worker is a background concern: the workspace must not be slower to appear
	// because a cache is being prepared, and a browser that refuses the
	// registration — no HTTPS, storage disabled, an unsupported engine — must
	// still get a working product. `registerServiceWorker` never throws and says
	// what happened; see its own header for why this is the right amount of
	// failure handling and not too little.
	void registerServiceWorker();
}
